<dcc-query-builder
  [isLoading]="isLoading"
  [options]="queryOptions"
  [query]="query"
  [total]="totalCount"
  (search)="onSearch($event)">
  <dcc-share-link-button></dcc-share-link-button>
  <dcc-download-csv-button
    (download)="onRequestCsv()"></dcc-download-csv-button>
</dcc-query-builder>

<ag-grid-angular
  class="ag-theme-alpine ag-grid-sticky-header"
  domLayout="autoHeight"
  rowSelection="single"
  style="width: 100%; height: 100%"
  [columnDefs]="columnDefinitions"
  [defaultColDef]="defaultColumnConfiguration"
  [enableBrowserTooltips]="true"
  [enableCellTextSelection]="true"
  [ensureDomOrder]="true"
  [pagination]="false"
  [rowData]="records"
  [suppressRowHoverHighlight]="true"></ag-grid-angular>

<dcc-spinner *ngIf="isLoading"></dcc-spinner>

<simple-paginator
  *ngIf="records?.length"
  [pageCount]="pageCount"
  [pageNumber]="pageNumber"
  (clickFirst)="onClickFirst()"
  (clickNext)="onPaginate()"></simple-paginator>
